/*eslint no-unused-vars:0 no-trailing-spaces:0 */
/*global sessionStorage */
let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let radio = require("ES/lib/radio");
let esUtils = require("ES/utils/esUtils");
let HoverMixin = require("ES/utils/HoverMixin");
let AuthedUserSession = require("../../../../../../utils/AuthedUserSession");

let modals = {
    ParentChildMessageModal: require("./ParentChildMessageModal"),
    DetachFromParentModal: require("./DetachFromParentModal"),
    AttachExistingChildModal: require("./AttachExistingChildModal")
};

module.exports = dd.createClass({
    mixins: [HoverMixin],
    getInitialState(){
        return {show_dd: null, show_modal: null};
    },
    __toggleDD(direction){
        return _.bind(esUtils.wrapPreventDefault(function () {
            if (this.state.show_dd === direction) {
                this.setState({show_dd: null});
            } else {
                this.setState({show_dd: direction});
            }
        }), this);
    },
    hoverable_onUserLeftHoverable(){
        if (this.state.show_dd) {//only setState if needed
            this.setState({show_dd: null});
        }
    },
    __itemClick(action){
        if (!_.isFunction(action)) {
            return null;
        }
        return _.bind(function (e) {
            this.setState({show_dd: null});
            action(e);
        }, this);
    },
    __disableClick: esUtils.wrapPreventDefault(_.noop),
    __searchFamily: esUtils.wrapPreventDefault(function () {
        let {event} = this.props;
        radio("EventSearchAside_search").broadcast({
            parenteid: event.parentID > 0 ? event.parentID : event.eid
        });
    }),
    __toggleModal(modal_name){
        return _.bind(esUtils.wrapPreventDefault(function () {
            if (this.state.show_modal === modal_name) {
                this.setState({show_modal: null});
            } else {
                this.setState({show_modal: modal_name});
            }
        }), this);
    },
    __openNewChildForm: esUtils.wrapPreventDefault(function () {
        let {event} = this.props;
        // set parent event data in session storage
        sessionStorage.setItem('parent_organization', event.organization);
        sessionStorage.setItem('parent_status', event.status);
        sessionStorage.setItem('parent_bureauID', event.bureauID);
        sessionStorage.setItem('parent_pd_rep_id', event.pd_rep_id);
        sessionStorage.setItem('parent_sales_rep_id', event.sales_rep_id);
        sessionStorage.setItem('parent_project_manager_id', event.project_manager_id);
        sessionStorage.setItem('parent_bureauNotes', event.bureauNotes);
        sessionStorage.setItem('parent_sids', JSON.stringify(event.sids));
        sessionStorage.setItem('parent_Venue', JSON.stringify(event.Venue));
        // send to new event form now
        window.location.hash = '#/events/new/child/' + event.eid;
    }),
    render(){
        let {event, Displaylists} = this.props;
        let {show_dd, show_modal} = this.state;

        if (!AuthedUserSession.is_st_family) {
            let pro_sids = AuthedUserSession.getSIDsAtPackageLevel("PRO");
            if (!_.any(event.sids, _.partial(_.includes, pro_sids))) {
                return dd.span();//hide
            }
        }

        let has_parent = event.parentID > 0;
        let has_children = !_.isEmpty(event.childevents);
        let dd_items = [
            show_dd === "up"
                ? {name: "Open parent event", href: "#/events/" + event.parentID, no_click: !has_parent}
                : {name: "Create a new child event...", onClick: this.__openNewChildForm},

            show_dd === "up"
                ? {name: "Detach from parent event", onClick: this.__toggleModal("DetachFromParentModal"), no_click: !has_parent}
                : {name: "Attach existing event as child...", onClick: this.__toggleModal("AttachExistingChildModal")},

            {name: "Search the family", onClick: this.__searchFamily, no_click: !has_parent && !has_children}
        ];
        if (!_.isEmpty(event.childevents) && show_dd === "down") {
            dd_items.push({divider: true});
            _.each(event.childevents, function (child) {
                dd_items.push({name: child.organization || "event #" + child.id, href: "#/events/" + child.id});
            });
        }

        let renderToggleHandle = _.bind(function (direction, disabled) {
            if (disabled) {
                return dd.span({className: "text-verymuted no-select"},
                    dd.i({className: "fa fa-arrow-circle-" + direction})
                );
            }
            return dd.a({href: "#", className: "dropdown-toggle", onClick: this.__toggleDD(direction)},
                dd.i({className: "fa fa-arrow-circle-" + direction})
            );
        }, this);

        let warning_msg = event.message_that_parent_child_services_dont_add_upon_resc_and_pd_values;
        warning_msg = esUtils.isBlank(warning_msg) ? false : warning_msg;
        warning_msg = AuthedUserSession.doIHaveAccess.limited_speaker.any(event.sids) ? null : warning_msg;

        return dd.div({
                style: {
                    display: "inline-block"
                },
                className: "dropdown relative " + (show_dd ? "open" : ""),
                onMouseEnter: this.hoverable_onMouseEnter,
                onMouseLeave: this.hoverable_onMouseLeave
            },
            warning_msg ? dd.a({href: "#", onClick: this.__toggleModal("ParentChildMessageModal")},
                dd.i({className: "fa fa-warning"})
            ) : null,
            " ",
            renderToggleHandle("up", !has_parent), " ", renderToggleHandle("down", has_parent),
            dd.ul({className: "dropdown-menu dropdown-menu-right", role: "menu", style: {marginRight: show_dd === "up" ? "1em" : ""}},
                _.map(dd_items, function (item, i) {
                    if (item.divider) {
                        return dd.li({key: i, className: "divider"});
                    }
                    return dd.li({key: i, role: "presentation", className: item.no_click ? "disabled" : null},
                        dd.a({role: "menuitem", href: item.href || "#", onClick: item.no_click ? this.__disableClick : this.__itemClick(item.onClick)}, item.name)
                    );
                }, this)
            ),
            _.map(modals, function (cmpt, name) {
                return show_modal === name ? cmpt({key: name, event, Displaylists, message: warning_msg, onClose: this.__toggleModal(name)}) : null;
            }, this)
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/details/ParentChildControls/index.js